var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.75 6.25C70.4076 6.25 71.9973 6.90848 73.1694 8.08058C74.3415 9.25268 75 10.8424 75 12.5V87.5C75 89.1576 74.3415 90.7473 73.1694 91.9194C71.9973 93.0915 70.4076 93.75 68.75 93.75H31.25C29.5924 93.75 28.0027 93.0915 26.8306 91.9194C25.6585 90.7473 25 89.1576 25 87.5V12.5C25 10.8424 25.6585 9.25268 26.8306 8.08058C28.0027 6.90848 29.5924 6.25 31.25 6.25H68.75ZM31.25 0C27.9348 0 24.7554 1.31696 22.4112 3.66117C20.067 6.00537 18.75 9.18479 18.75 12.5V87.5C18.75 90.8152 20.067 93.9946 22.4112 96.3388C24.7554 98.683 27.9348 100 31.25 100H68.75C72.0652 100 75.2446 98.683 77.5888 96.3388C79.933 93.9946 81.25 90.8152 81.25 87.5V12.5C81.25 9.18479 79.933 6.00537 77.5888 3.66117C75.2446 1.31696 72.0652 0 68.75 0L31.25 0Z",
    fill: "#98A6AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 87.5C51.6576 87.5 53.2473 86.8415 54.4194 85.6694C55.5915 84.4973 56.25 82.9076 56.25 81.25C56.25 79.5924 55.5915 78.0027 54.4194 76.8306C53.2473 75.6585 51.6576 75 50 75C48.3424 75 46.7527 75.6585 45.5806 76.8306C44.4085 78.0027 43.75 79.5924 43.75 81.25C43.75 82.9076 44.4085 84.4973 45.5806 85.6694C46.7527 86.8415 48.3424 87.5 50 87.5Z",
    fill: "#98A6AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.15b79c888d034087a4a0bd92d05600f8.svg";
export { ForwardRef as ReactComponent };